export enum UserRoles {
    ROLE_INDUSTRIEPARTNER = 'ROLE_INDUSTRIEPARTNER',
    ROLE_INDUSTRIEPARTNER_SUB = 'ROLE_INDUSTRIEPARTNER_SUB',
    ROLE_ADMIN = 'ROLE_ADMIN',
    ROLE_APOTHEKE = 'ROLE_APOTHEKE'
}
